import i18n from "@/i18n";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: createEventFunc({
      ...payload,
      path: `_hook.${hookId}`
    })
  }
});

export default {
  ...createEventMap(HookCodes.COST_CREATED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.COST_DELETED, {
    icon: icon.danger
  }),
  ...createEventMap(HookCodes.COST_UPDATED)
};
